//
// Copyright (C) 2021 The Android Open Source Project
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.7.0 with parameter "target=ts,import_extension=none"
// @generated from file android/hardware/automotive/vehicle/VehicleAreaConfig.proto (package android.hardware.automotive.vehicle.proto, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { VehiclePropertyAccess } from "./VehiclePropertyAccess_pb";
import { file_android_hardware_automotive_vehicle_VehiclePropertyAccess } from "./VehiclePropertyAccess_pb";
import type { HasSupportedValueInfo } from "./HasSupportedValueInfo_pb";
import { file_android_hardware_automotive_vehicle_HasSupportedValueInfo } from "./HasSupportedValueInfo_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file android/hardware/automotive/vehicle/VehicleAreaConfig.proto.
 */
export const file_android_hardware_automotive_vehicle_VehicleAreaConfig: GenFile = /*@__PURE__*/
  fileDesc("CjthbmRyb2lkL2hhcmR3YXJlL2F1dG9tb3RpdmUvdmVoaWNsZS9WZWhpY2xlQXJlYUNvbmZpZy5wcm90bxIpYW5kcm9pZC5oYXJkd2FyZS5hdXRvbW90aXZlLnZlaGljbGUucHJvdG8itQMKEVZlaGljbGVBcmVhQ29uZmlnEg8KB2FyZWFfaWQYASABKAUSFwoPbWluX2ludDMyX3ZhbHVlGAIgASgFEhcKD21heF9pbnQzMl92YWx1ZRgDIAEoBRIXCg9taW5faW50NjRfdmFsdWUYBCABKAMSFwoPbWF4X2ludDY0X3ZhbHVlGAUgASgDEhcKD21pbl9mbG9hdF92YWx1ZRgGIAEoAhIXCg9tYXhfZmxvYXRfdmFsdWUYByABKAISHQoVc3VwcG9ydGVkX2VudW1fdmFsdWVzGAggAygDElAKBmFjY2VzcxgJIAEoDjJALmFuZHJvaWQuaGFyZHdhcmUuYXV0b21vdGl2ZS52ZWhpY2xlLnByb3RvLlZlaGljbGVQcm9wZXJ0eUFjY2VzcxIkChxzdXBwb3J0X3ZhcmlhYmxlX3VwZGF0ZV9yYXRlGAogASgIEmIKGGhhc19zdXBwb3J0ZWRfdmFsdWVfaW5mbxgLIAEoCzJALmFuZHJvaWQuaGFyZHdhcmUuYXV0b21vdGl2ZS52ZWhpY2xlLnByb3RvLkhhc1N1cHBvcnRlZFZhbHVlSW5mb2IGcHJvdG8z", [file_android_hardware_automotive_vehicle_VehiclePropertyAccess, file_android_hardware_automotive_vehicle_HasSupportedValueInfo]);

/**
 * Must be in sync with VehicleAreaConfig.aidl. 
 *
 * @generated from message android.hardware.automotive.vehicle.proto.VehicleAreaConfig
 */
export type VehicleAreaConfig = Message<"android.hardware.automotive.vehicle.proto.VehicleAreaConfig"> & {
  /**
   * Area id is ignored for VehiclePropertyGroup:GLOBAL properties. 
   *
   * @generated from field: int32 area_id = 1;
   */
  areaId: number;

  /**
   * If the property has @data_enum, leave the range to zero.
   *
   * Range will be ignored in the following cases:
   *    - The VehiclePropertyType is not INT32, INT64 or FLOAT.
   *    - Both of min value and max value are zero. 
   *
   * @generated from field: int32 min_int32_value = 2;
   */
  minInt32Value: number;

  /**
   * @generated from field: int32 max_int32_value = 3;
   */
  maxInt32Value: number;

  /**
   * @generated from field: int64 min_int64_value = 4;
   */
  minInt64Value: bigint;

  /**
   * @generated from field: int64 max_int64_value = 5;
   */
  maxInt64Value: bigint;

  /**
   * @generated from field: float min_float_value = 6;
   */
  minFloatValue: number;

  /**
   * @generated from field: float max_float_value = 7;
   */
  maxFloatValue: number;

  /**
   * *
   * If the property has a @data_enum, then it is possible to specify a supported subset of the
   * @data_enum. If the property has a @data_enum and supported_enum_values is null, then it is
   * assumed all @data_enum values are supported unless specified through another mechanism.
   *
   * @generated from field: repeated int64 supported_enum_values = 8;
   */
  supportedEnumValues: bigint[];

  /**
   * @generated from field: android.hardware.automotive.vehicle.proto.VehiclePropertyAccess access = 9;
   */
  access: VehiclePropertyAccess;

  /**
   * @generated from field: bool support_variable_update_rate = 10;
   */
  supportVariableUpdateRate: boolean;

  /**
   * *
   * This specifies whether this property may have min/max supported value or supported values
   * list for [propId, areaId] that supports new supported values APIs.
   *
   * If this is not {@code null}. The client may use {@code getMinMaxSupportedValue},
   * {@code getSupportedValuesLists}, {@code subscribeSupportedValueChange},
   * {@code unsubscribeSupportedValueChange}.
   *
   * If this is not {@code null}. The VHAL implementation must implement
   * {@code getMinMaxSupportedValue}, {@code getSupportedValuesLists},
   * {@code subscribeSupportedValueChange} for the [propId, areaId].
   *
   * This should be non-null if the VHAL implementation wants to expose
   * min/max supported value or supported values list that may change dynamically. For example,
   * if the max HVAC fan speed may change due to HVAC power settings.
   *
   * This should not be non-null if the VHAL implementation wants to expose supported
   * values list for property ID that is not an enum type (hence do not support
   * {@code VehicleAreaConfig#supportedEnumValues}).
   *
   * If this is {@code null}, the APIs mentioned before are not supported.
   * Client must fallback to use static supported value information in {@code VehicleAreaConfig}.
   *
   * For VHAL implementation < V4, this is always {@code null}.
   *
   * @generated from field: android.hardware.automotive.vehicle.proto.HasSupportedValueInfo has_supported_value_info = 11;
   */
  hasSupportedValueInfo?: HasSupportedValueInfo;
};

/**
 * Describes the message android.hardware.automotive.vehicle.proto.VehicleAreaConfig.
 * Use `create(VehicleAreaConfigSchema)` to create a new message.
 */
export const VehicleAreaConfigSchema: GenMessage<VehicleAreaConfig> = /*@__PURE__*/
  messageDesc(file_android_hardware_automotive_vehicle_VehicleAreaConfig, 0);

